import { Input, InputGroup } from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import './Layout.css';

const Search = ({
    searchTxt,
    handleInput,
    placeholder,
    label
}: {
    searchTxt: string;
    handleInput: (e: any) => void;
    placeholder: string;
    label?: string;
}) => (
    <div className="invite-input-wrapper">
        <label htmlFor="">{label}</label>
        <InputGroup className="input-box">
            <Input
                value={searchTxt}
                onChange={handleInput}
                placeholder={placeholder}
            />
            <InputGroup.Button>
                <SearchIcon1 color="var(--rs-primary-600)" size="18px" />
            </InputGroup.Button>
        </InputGroup>
    </div>
);

const SearchIcon1 = ({ size, color }: { size: string; color: string }) => (
    <SearchIcon style={{ color, fontSize: size }} />
);

export default Search;